export default __webpack_public_path__ + "static/media/login-road-background-desktop.0bdff77e.png";